<template>
    <div>
        <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>
        <input type="hidden" :name="this.name" v-model="content">
    </div>
</template>

<script>
    // npm install vue2-editor
    import { VueEditor } from "vue2-editor";

    export default {

        props:['name','value'],

        data() {
            return {
                content: this.value,
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    ['blockquote'],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{'font':[]}, { 'color': [] }, { 'background': [] }],
                    ['link', 'image', 'video'],
                    [{ 'align': [] }],
                    ['clean']
                ],
            }
        },

    }
</script>

